import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Kit-local class merger.
 *
 * The kit deliberately does NOT import the host app's `cn` — `.app` keeps it at
 * `@/lib/cn` and `.men` at `@/lib/utils`. Owning it here is what lets a kit file
 * drop into either repo untouched.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
